import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Badge, Button, Col, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import api from '../../../services/api';
import { Prefix } from '../../../services/prefix';
import { useFetch } from '../../../components/hooks/useFetch';
import { AsyncPaginate } from 'react-select-async-paginate';
import { colourStyles } from '../../selectAsync/colourStyles';
import { loadOptions } from '../../selectAsync/loadOptions';
import { ModalContainer } from "../../../style/stylesModals";
import { CustomButton, TextButton } from "../../../style/stylesButton";
import { v4 as uuidv4 } from 'uuid';
import { FaPencilAlt } from 'react-icons/fa';

const EditEquipamentsModel = ({ id, rowsPage, pageExact, search, orderBy, order, GlobalMutate }) => {
  const [show, setShow] = useState(false);
  const [families, setFamilies] = useState(0);
  const [registerData, setRegisterData] = useState({
    active: 1,
    name: '',
    id_equipment_brand: '',
    id_equipment_category: '',
    anvisa_registry: '',
    measures: [],
  });
  const [valueSelect, setValueSelect] = useState([]);
  const [valueSelectArray, setValueSelectArray] = useState([]);
  const [removeList, setRemoveList] = useState([]);

  const equipmentsList = useFetch(
    !show ? null : Prefix.replace(/[\\"]/g, '') + '/equipment-models/' + id
  );

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    if (equipmentsList.data) {
      const model = equipmentsList.data.model;
      const category = { value: model.id_equipment_category, label: model.equipment_category.name, nameField: 'id_equipment_category' };
      const brand = { value: model.id_equipment_brand, label: model?.equipment_brand?.name, nameField: 'id_equipment_brand' };
      setValueSelect([category, brand]);

      const measures = model.profile_attributes.map((attr) => ({
        id: attr.id,
        value: attr.id_unit_of_measure,
        label: `${attr.unit_of_measure.measure.name} (${attr.unit_of_measure.name})`,
      }));
      setValueSelectArray(measures);

      setRegisterData({
        active: 1,
        name: model.name,
        id_equipment_brand: model.id_equipment_brand,
        id_equipment_category: model.id_equipment_category,
        anvisa_registry: model.anvisa_registry,
        measures: model.profile_attributes,
      });

      fetchFamily(model.id_equipment_category);
    }
  }, [equipmentsList.data]);

  const fetchFamily = async (categoryId) => {
    try {
      const { data } = await api.get(Prefix.replace(/[\\"]/g, '') + `/equipment-categories/${categoryId}`);
      setFamilies(data.model.equipment_family.monitoring === 1 ? 1 : 0);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSelectChange = (e, name) => {
    setValueSelect((prev) => [
      ...prev.filter((item) => item.nameField !== name),
      { value: e.value, label: e.label, nameField: name },
    ]);
    setRegisterData((prev) => ({ ...prev, [name]: e.value }));
    if (name === 'id_equipment_category') fetchFamily(e.value);
  };

  const handleMeasureChange = (index, field, value) => {
    const updated = [...registerData.measures];
    updated[index] = { ...updated[index], [field]: value };
    setRegisterData((prev) => ({ ...prev, measures: updated }));
  };

  const handleMeasureSelectChange = (index, e) => {
    const updated = [...registerData.measures];
    updated[index] = { ...updated[index], id_unit_of_measure: e.value };
    setRegisterData((prev) => ({ ...prev, measures: updated }));
    setValueSelectArray((prev) => [
      ...prev.filter((m) => m.id !== updated[index].id),
      { id: updated[index].id, value: e.value, label: e.label },
    ]);
  };

  const addMeasure = () => {
    const newMeasure = {
      id: uuidv4(),
      id_unit_of_measure: null,
      min: -200,
      max: 300,
      safety_margin: 2,
      safety_margin_time: '',
    };
    setRegisterData((prev) => ({ ...prev, measures: [...prev.measures, newMeasure] }));
  };

  const removeMeasure = (index) => {
    const measureId = registerData.measures[index].id;
    setRemoveList((prev) => [...prev, measureId]);
    setRegisterData((prev) => ({
      ...prev,
      measures: prev.measures.filter((_, i) => i !== index),
    }));
    setValueSelectArray((prev) => prev.filter((m) => m.id !== measureId));
  };

  function HandleRegister() {
    const valuesSend = {
      active: registerData.active,
      name: registerData.name,
      id_equipment_brand: registerData.id_equipment_brand,
      id_equipment_category: registerData.id_equipment_category,
      anvisa_registry: registerData.anvisa_registry,
    };
    api
      .put(Prefix.replace(/[\\"]/g, '') + '/equipment-models/' + id, valuesSend)
      .then((response) => {
        removeList.map((map) => {
          api.delete(Prefix.replace(/[\\"]/g, '') + '/profile-attributes/' + map);
        });

        if (families === 1) {
          registerData.measures.map((atrib) =>
            api
              .put(Prefix.replace(/[\\"]/g, '') + '/profile-attributes/' + atrib.id, {
                active: 1,
                id_equipment_model: response.data.model.id,
                id_unit_of_measure: atrib.id_unit_of_measure,
                min: atrib.min,
                max: atrib.max,
                safety_margin: atrib.safety_margin,
                safety_margin_time: atrib.safety_margin_time,
              })
              .catch(() => {
                api.post(Prefix.replace(/[\\"]/g, '') + '/profile-attributes', {
                  active: 1,
                  id_equipment_model: response.data.model.id,
                  id_unit_of_measure: atrib.id_unit_of_measure,
                  min: atrib.min,
                  max: atrib.max,
                  safety_margin: atrib.safety_margin,
                  safety_margin_time: atrib.safety_margin_time,
                });
              }),
          );
        }

        Swal.fire({
          icon: 'success',
          title: 'Uow!',
          text: response.data.message,
          confirmButtonText: 'Fechar',
          showCancelButton: true,
          cancelButtonText: 'Novo Cadastro',
        }).then(() => {
          setShow(false);
          setRegisterData({
            active: 1,
            name: '',
            id_equipment_brand: '',
            id_equipment_category: '',
            anvisa_registry: '',
            measures: [],
          });
          setFamilies(0);
          setValueSelect([]);
        });

        GlobalMutate(
          Prefix.replace(/[\\"]/g, '') +
            '/equipment-models?per_page=' +
            rowsPage +
            '&page=' +
            pageExact +
            '&search=' +
            search +
            '&order_by=' +
            orderBy +
            '&order=' +
            order,
        );
      })
      .catch((err) => {
        console.log('aaaa', err)
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Oops...',
        //   text: err.response.data.message,
        //   confirmButtonText: 'Tentar novamente',
        // });
      });
  }

  return (
    <>
      {!show ? (
        <Link to="#" onClick={handleShow} className="link_color_datatable">
          <FaPencilAlt />
        </Link>
      ) : (
        <ModalContainer show={show} onHide={handleClose} backdrop="static" keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title><h3>Atualizar<br /> modelo de equipamento</h3></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <div className="formStep">
                  <label className="important">Categoria:</label>
                  <AsyncPaginate
                    value={valueSelect.filter(v => v.nameField === 'id_equipment_category').map(v => ({ value: v.value, label: v.label }))}
                    loadOptions={loadOptions}
                    onChange={(e) => handleSelectChange(e, 'id_equipment_category')}
                    placeholder="Selecione..."
                    cacheUniqs={[valueSelect]}
                    styles={colourStyles}
                    additional={{ page: 1, endpoint: '/equipment-categories' }}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="formStep">
                  <label className="important">Marca:</label>
                  <AsyncPaginate
                    value={valueSelect.filter(v => v.nameField === 'id_equipment_brand').map(v => ({ value: v.value, label: v.label }))}
                    loadOptions={loadOptions}
                    onChange={(e) => handleSelectChange(e, 'id_equipment_brand')}
                    placeholder="Selecione..."
                    cacheUniqs={[valueSelect]}
                    styles={colourStyles}
                    additional={{ page: 1, endpoint: '/equipment-brands' }}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="formStep">
                  <label className="important">Nome do modelo:</label>
                  <input
                    type="text"
                    value={registerData.name}
                    onChange={(e) => setRegisterData({ ...registerData, name: e.target.value })}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="formStep">
                  <label className="important">Registro da Anvisa:</label>
                  <input
                    type="text"
                    value={registerData.anvisa_registry}
                    onChange={(e) => setRegisterData({ ...registerData, anvisa_registry: e.target.value })}
                  />
                </div>
              </Col>
            </Row>

            {families === 1 && (
              <>
                <Row>
                  <Col className="attrTitle d-flex justify-content-between mb-3">
                    <div>Atributos de Monitoramento</div>
                    <Badge style={{ color: 'white', cursor: 'pointer' }} variant="success" onClick={addMeasure}>Adicionar</Badge>
                  </Col>
                </Row>
                {registerData.measures.map((measure, index) => (
                  <Row className="rowAttr rowAttr_in mb-4" key={measure.id}>
                    <Col xs={12}>
                      <div className="formStep d-flex align-items-center justify-content-between">
                        <label className="important">Grandeza</label>
                        <Button variant="danger" onClick={() => removeMeasure(index)}>X</Button>
                      </div>
                      <AsyncPaginate
                        value={valueSelectArray.filter((v) => v.id === measure.id).map((v) => ({ value: v.value, label: v.label }))}
                        loadOptions={loadOptions}
                        onChange={(e) => handleMeasureSelectChange(index, e)}
                        placeholder="Selecione..."
                        cacheUniqs={[valueSelectArray]}
                        styles={colourStyles}
                        additional={{ page: 1, endpoint: '/unit-of-measures' }}
                      />
                    </Col>

                    {['min', 'max', 'safety_margin', 'safety_margin_time'].map((field) => (
                      <Col xs={12} key={field}>
                        <div className="formStep">
                          <label className="important">{field === 'min' ? 'Mínimo' : field === 'max' ? 'Máximo' : field === 'safety_margin' ? 'Margem de segurança' : 'Tempo offline'}</label>
                          <input
                            type="number"
                            value={measure[field]}
                            step={field === 'safety_margin' ? 0.25 : 1}
                            min={field === 'safety_margin' ? 0.25 : undefined}
                            onChange={(e) => handleMeasureChange(index, field, e.target.value)}
                          />
                        </div>
                      </Col>
                    ))}
                  </Row>
                ))}
              </>
            )}

            <Row>
              <Col className="d-flex justify-content-center mt-3">
                <CustomButton onClick={HandleRegister}>
                  <TextButton>Atualizar</TextButton>
                </CustomButton>
              </Col>
            </Row>
          </Modal.Body>
        </ModalContainer>
      )}
    </>
  );
};

export default EditEquipamentsModel;
